export const isLTL = (
  isWhiteGlove: boolean,
  isEntryway: boolean,
): boolean => isWhiteGlove || isEntryway

export const isParcel = (
  isWhiteGlove: boolean,
  isEntryway: boolean,
): boolean => !isWhiteGlove && !isEntryway
